// extracted by mini-css-extract-plugin
module.exports = {"submenu":"SubMenu-module--submenu--STdNZ Box-module--box--X0EGm"};